import { gql } from "graphql-request"

const crypto_mainnet = {
    name: 'crypto_mainnet',
    title: 'Crypto.org Mainnet',
    currency: 'CRO',
    check: true,
    regexp: '([\\W]|^)(cro[0-9a-z]{39})([\\W]|$)',
    noregxp: [
        '([\\W]|^)(bnb[0-9a-z]{2})([\\W]|$)',
        '([\\W]|^)(bnb[0-9a-z]{2)([\\W]|$)',
        '([\\W]|^)(T[\\w]{2})([\\W]|$)',
        '([\\W]|^)(T[\\w]{2})([\\W]|$)',
    ],
    query: gql`query ($address: String!) {
        crypto_mainnet: cosmos(network: crypto_mainnet) {
            address(address: {is: $address}){
                balance:balance
                balance_usd: balance(in: USD)
            }
            ins: transfers(receiver: {is: $address}) {
                count
                min_date: minimum(of: date)
                max_date: maximum(of: date)
            }
            currencyIn: transfers(receiver: {is: $address}) {
                count
                currency {
                    symbol
                    address
                    tokenId
                }
            }
            outs: transfers(sender: {is: $address}) {
                count
                min_date: minimum(of: date)
                max_date: maximum(of: date)
            }
            currencyOut: transfers(sender: {is: $address}) {
                count
                currency {
                    symbol
                    address
                    tokenId
                }
            }
        }
    }`,
    checkAddress: 'cro1pw0485nd5vekjnqac23dxk9jvldrr5muga29dv',
}
export { crypto_mainnet }
